<p>Producer, 2022-present</p>
<p>
    <a href="https://www.thepitch.show/" target="_blank">The Pitch</a> 
    is a weekly Shark-Tank-style 
    <a href="https://open.spotify.com/show/0L04op9D76TOfmzm7yOf9T?si=eb47c966485c4794" target="_blank">audio</a> & 
    <a href="https://www.youtube.com/@thepitchshow" target="_blank">video</a> podcast.</p>

<app-project-gallery [galleryItems]="galleryItems"></app-project-gallery>
<!-- <div class="grid-container">
    <app-embedded-video class="grid-item" [videoId]="episode1Id"></app-embedded-video>
    <app-embedded-video class="grid-item" [videoId]="episode2Id"></app-embedded-video>
    <app-embedded-video class="grid-item" [videoId]="episode3Id"></app-embedded-video>
    <app-embedded-video class="grid-item" [videoId]="episode4Id"></app-embedded-video>
</div> -->
